import { Dropdown, Menu, Select, Slider, Checkbox } from "antd";
import React, { useState } from "react";
import AutoCompleteSearch from "../../../../common/components/AutoComplete/AutoCompleteSearch";
import { ExpandSVG } from "../../../../common/components/icons/SVGIcon";

const { Option } = Select;

const OverviewFilter = ({
  autoCompleteOptions,
  valueSearch,
  providers,
  onChangeDate,
  onChangeProvider,
  onChangeAssignment,
  onChangeSlary,
  onSelectCustomReport,
  onSelectFilter0IB,
  hideProvider,
}) => {
  const [search, setSearch] = useState("");
  const [slary, setSlary] = useState([0, 100000]);

  const changeSearch = (value) => {
    setSearch(value);
    valueSearch(value);
  };

  const handleItemClick = (item) => {
    const { first_name, last_name } = item;
    const value = `${first_name} ${last_name}`;
    if (value) {
      valueSearch(value);
    }
  };

  const menu = (
    <Menu>
      <Menu.Item
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Slider
          range
          style={{ width: "100%" }}
          step={1000}
          max={100000}
          defaultValue={slary}
          onChange={(value) => setSlary(value)}
          onAfterChange={(value) => onChangeSlary(value)}
        />
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="filterContainer">
      <div className="searchFieldContainer">
        <div className="searchField">
          <AutoCompleteSearch
            isNotTargetInput={true}
            isEmployeeWorkFlow={true}
            handlePopulate={(item) => handleItemClick(item)}
            title="Patient-Search"
            options={autoCompleteOptions}
            handleSearch={(value) => changeSearch(value)}
            placeholder="Search Patient"
            keyLabel="patient_name"
            actionLabel="Search"
            backgroundWhite={"white"}
          />
        </div>
      </div>

      <div className="statusFilter" style={{ minWidth: "200px" }}>
        <Select placeholder="Filter by Assignment" suffixIcon={<ExpandSVG />} onChange={onChangeAssignment} allowClear={true}>
          {[
            {
              name: "Less Than 30 Days",
              id: "green",
            },
            {
              name: "31 to 60 days",
              id: "30_to_60",
            },
            {
              name: "61 to 90 days",
              id: "60_to_90",
            },
            {
              name: "91 to 120 days",
              id: "90_to_120",
            },
            {
              name: "Over 120 days",
              id: "over_120",
            },
            {
              name: "Collection",
              id: "collection",
            },
            {
              name: "Insurance Aging",
              id: "insurance_aging",
            },
            {
              name: "Needs Review",
              id: "needs_review",
            },
            {
              name: "Attention Required",
              id: "attention_required",
            },
            {
              name: "Ok waiting payment",
              id: "ok_waiting_payment",
            },
          ].map((items) => {
            return (
              <Option key={items?.id} value={items?.id}>
                {items?.name}
              </Option>
            );
          })}
        </Select>
      </div>

      <div className="statusFilterContainer">
        {hideProvider ? null : (
          <div className="statusFilter" style={{ minWidth: "200px" }}>
            <Select placeholder="Filter by Provider" suffixIcon={<ExpandSVG />} onChange={onChangeProvider} allowClear={true}>
              {providers.map((items) => {
                return (
                  <Option key={items?.id} value={items?.id}>
                    {items?.name}
                  </Option>
                );
              })}
            </Select>
          </div>
        )}

        <Dropdown overlay={menu} placement="bottomCenter">
          <div
            className="statusFilter"
            style={{
              minWidth: "200px",
              backgroundColor: "#fff",
              marginTop: 11,
              flexDirection: "column",
              minHeight: "40px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p style={{ fontSize: 13 }}>{`${slary[0]}$ <--> ${slary[1]}$`}</p>
          </div>
        </Dropdown>

        <Checkbox style={{ marginLeft: 10, marginTop: 10 }} onChange={(e) => onSelectFilter0IB(e)}>
          <span style={{ fontSize: 13 }}>Exclude 0 Insurance Balance</span>
        </Checkbox>
      </div>
    </div>
  );
};

export default OverviewFilter;
